<template>
  <rbz-modal-dialog
    :show="systemOutOfDate"
    :title="$t('update.modal.title')"
    :hide-close-icon="true"
    :primary-btn-title="$t('update.modal.refreshSystem')"
    :primary-btn-ignore-update-in-process="true"
    @onPrimaryBtnClick="refreshSystem()"
    size="medium"
  >
    <template #content>
      {{ $t('update.modal.message') }}
    </template>
  </rbz-modal-dialog>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { mapStores } from 'pinia';
import RbzModalDialog from '@/components/RbzModalDialog.vue';
import { usePlanetStore } from '@/store/PlanetStore';

export default defineComponent({
  name: 'IdleModal',
  components: { RbzModalDialog },
  computed: {
    systemOutOfDate(): boolean {
      return this.planetStore.systemOutOfDate;
    },

    ...mapStores(usePlanetStore),
  },
  methods: {
    refreshSystem() {
      this.$router.go(0);
    },
  },
});
</script>
